export default function initLoadMoreDownloads() {

    if (!document.body.classList.contains('post-type-archive-download')) {
        return;
    }

    const customLoadMoreBtn = document.getElementById('js-load-more-downloads');

    if (!customLoadMoreBtn) return;

    // 1. Repassa o clique do nosso botão para o botão nativo do ASP
    customLoadMoreBtn.addEventListener('click', () => {
        // O ASP gera um link com essa classe quando tem paginação ativada
        const aspLoadMore = document.querySelector('.asp_showmore');

        if (aspLoadMore) {
            aspLoadMore.click();
        }
    });

    // 2. Controla a visibilidade do nosso botão
    // O ASP dispara um evento customizado no Window sempre que termina uma busca/carregamento
    window.addEventListener('ASP_search_end', () => {
        // Dá um pequeno timeout de 100ms para garantir que o ASP já injetou o novo HTML dele no DOM
        setTimeout(() => {
            const aspLoadMore = document.querySelector('.asp_showmore');

            // Se o botão do ASP existir e não estiver oculto, mostramos o nosso
            if (aspLoadMore && aspLoadMore.style.display !== 'none') {
                // Removemos o display: none forçado
                customLoadMoreBtn.style.display = '';
            } else {
                // Se o ASP escondeu o dele (porque os itens acabaram), escondemos o nosso!
                customLoadMoreBtn.style.display = 'none';
            }
        }, 100);
    });

    // 3. Execução inicial para checar o estado no load da página
    setTimeout(() => {
        const aspLoadMore = document.querySelector('.asp_showmore');
        if (!aspLoadMore) {
            customLoadMoreBtn.style.display = 'none';
        }
    }, 500); // Aguarda o carregamento inicial silencioso do ASP que fizemos antes
}